export const APP_BASE_URL_FROM_CONFIG = process.env.REACT_APP_BASE_URL || "http://localhost:3004/mlm/";
export const IMG_BASE_URL_FROM_CONFIG = process.env.REACT_APP_IMG_BASE_URL || "http://localhost:3004";
